<template>
  <div class="space-y-6">
    <div v-if="loading" class="flex justify-center py-12">
      <div class="spinner"></div>
    </div>
    
    <div v-else-if="profile" class="space-y-6">
      <!-- Header -->
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <button @click="$router.go(-1)" class="btn btn-secondary btn-sm mr-4">
            <ArrowLeftIcon class="w-4 h-4 mr-1" />
            Back
          </button>
          <div class="text-4xl mr-4">{{ profile.avatar || 'Y' }}</div>
          <div>
            <h1 class="text-3xl font-bold">{{ profile.name }}</h1>
            <p class="text-gray-500">{{ profile.relationship }} â€¢ {{ profile.age_range }}</p>
          </div>
        </div>
        <div class="flex space-x-2">
          <button @click="editProfile" class="btn btn-secondary">
            <PencilIcon class="w-5 h-5 mr-1" />
            Edit
          </button>
          <button @click="initiateCall" class="btn btn-primary">
            <PhoneIcon class="w-5 h-5 mr-1" />
            Call Now
          </button>
        </div>
      </div>
      
      <!-- Profile Info -->
      <div class="card">
        <div class="card-header">
          <h2 class="text-xl font-semibold">Profile Information</h2>
        </div>
        <div class="card-body">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="text-sm text-gray-500">Phone Number</label>
              <p class="font-medium">{{ profile.phone }}</p>
            </div>
            <div>
              <label class="text-sm text-gray-500">Preferred Call Time</label>
              <p class="font-medium">{{ profile.preferred_call_time || 'Not set' }}</p>
            </div>
            <div>
              <label class="text-sm text-gray-500">Status</label>
              <span :class="['badge', getStatusBadgeClass(profile.status)]">{{ profile.status }}</span>
            </div>
            <div>
              <label class="text-sm text-gray-500">Last Call</label>
              <p class="font-medium">{{ formatLastCall(profile.last_call_at) }}</p>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Recent Calls -->
      <div class="card">
        <div class="card-header">
          <h2 class="text-xl font-semibold">Recent Calls</h2>
        </div>
        <div class="card-body">
          <div class="text-center py-8 text-gray-500">
            Recent call history will appear here
          </div>
        </div>
      </div>
    </div>
    
    <div v-else class="text-center py-12">
      <p class="text-gray-500">Profile not found</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useCallStore } from '@/stores/calls'
import { useRoute, useRouter } from 'vue-router'
import { ArrowLeftIcon, PencilIcon, PhoneIcon } from '@heroicons/vue/24/outline'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

const route = useRoute()
const router = useRouter()
const callStore = useCallStore()

const loading = ref(true)
const profile = ref(null)

function getStatusBadgeClass(status) {
  const classes = {
    active: 'badge-success',
    paused: 'badge-warning',
    inactive: 'badge-danger'
  }
  return classes[status] || 'badge-info'
}

function formatLastCall(date) {
  if (!date) return 'Never'
  return dayjs(date).fromNow()
}

function editProfile() {
  // Open edit modal
  console.log('Edit profile:', profile.value)
}

async function initiateCall() {
  if (!profile.value?.id) return
  try {
    await callStore.initiateCall(profile.value.id)
  } catch (e) {
    console.error('Failed to initiate call:', e)
  }
}

onMounted(async () => {
  // Load profile data
  const profileId = route.params.id
  // Mock data for now
  profile.value = {
    id: profileId,
    name: 'Margaret Johnson',
    relationship: 'Mother',
    age_range: '78-82',
    avatar: 'Y',
    phone: '+1 (555) 123-4567',
    preferred_call_time: '10:00 AM',
    status: 'active',
    last_call_at: new Date(Date.now() - 2 * 60 * 60 * 1000) // 2 hours ago
  }
  loading.value = false
})
</script>



